import { useDispatch, useSelector } from 'react-redux';

import { itineraryRelocationsSelector } from 'store/itinerariesItem/relocations/selectors';
import { updateRelocationsThunk } from 'store/itinerariesItem/relocations/thunks';
import { setAppHasChangesAction } from 'store/unsavedChanges';
import { immutableRowUpdate } from 'utils/immutableFunctions';
import {
  useItinerariesItemSaveHandler,
  useItinerariesItemNextStepFormHandler,
} from 'utils/itineraries/functions/builderUtils';

import { getFilteredItems } from './utils';

export function useActions() {
  const dispatch = useDispatch();
  const items = useSelector(itineraryRelocationsSelector);
  const handleSave = useItinerariesItemSaveHandler();
  const handleNextStep = useItinerariesItemNextStepFormHandler({
    onBeforeNext: () => dispatch(setAppHasChangesAction(false)),
  });

  const handleItemChange = (itemIndex, data) => {
    dispatch(updateRelocationsThunk(itemIndex, data));
    dispatch(setAppHasChangesAction(true));
  };

  const handleItemRemove = async (id) => {
    const data = items.map((item) => (item?.id === id ? { ...item, _destroy: true } : item));
    await handleSave({ relocations: getFilteredItems(data) });
  };

  const handleItemEdit = async (item) => {
    const data = immutableRowUpdate(items, item);
    await handleSave({ relocations: getFilteredItems(data) });
  };

  return {
    handleItemRemove,
    handleItemChange,
    handleSave,
    handleNextStep,
    handleItemEdit,
  };
}
